import cn from 'classnames';
import type { MouseEvent, ReactNode } from 'react';
import { Col } from '../../col';
import { FileIcon } from '../../file-icon';
import { Row } from '../../row';
import { Text } from '../../typography';

import styles from './attachment.module.css';

export type AttachmentProperties = {
  byteSize?: string;
  contentType?: string;
  extra?: ReactNode;
  filename: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  url: string;
  variant?: AttachmentVariant;
};

export type AttachmentVariant = 'default' | 'inverted' | 'light';

const Attachment = ({
  byteSize,
  contentType,
  extra,
  filename,
  onClick,
  url,
  variant = 'default',
}: AttachmentProperties) => (
  <a
    className={cn(styles.attachment, {
      [styles['attachment--inverted'] ?? '']: variant === 'inverted',
      [styles['attachment--light'] ?? '']: variant === 'light',
    })}
    href={url}
    onClick={onClick}
    rel="noopener noreferrer"
    target="_blank"
  >
    <Row align="middle" gutter="xs" wrap={false}>
      <Col>
        <FileIcon contentType={contentType} size="large" url={url} />
      </Col>

      <Col flex={1}>
        <Text className={styles.attachment__filename} ellipsis size="small">
          {filename}
        </Text>

        <Row gutter="xs">
          {byteSize ? (
            <Col>
              <Text className={styles['attachment__byte-size']} size="small">
                {byteSize}
              </Text>
            </Col>
          ) : null}

          {extra ? <Col>{extra}</Col> : null}
        </Row>
      </Col>
    </Row>
  </a>
);

export default Attachment;
